/**
 * 악덕알리미 내제보건 — JS 렌더.
 * 내 제보 전체를 한 번에 받아(/b/ajax/report) 탭필터·검색·카운트를 클라에서 처리.
 * 상세 BS·배지는 공용 $j.F.Devil.{MyReport,Render} 사용.
 */
// 타입 → 탭 키. 심사중·정정(대기)은 진행건이므로 '제보(report)' 탭에 묶되 배지로 구분. (해제는 종결건이라 매핑 없음 → '전체'에만 노출)
// 회수는 전액회수만 존재(일부회수 개념 없음). 배지·accent 는 $j.F.Devil.Render 공용.
const TYPE_TAB = { '체불': 'report', '심사중': 'report', '정정': 'report', '임시': 'draft', '반려': 'reject', '회수': 'collect' };
const AMT_COLOR = { '회수': 'b-myc__amt--b', '정정': 'b-myc__amt--sm' }; // 금액색은 b-myc 전용

export default class My {
    constructor() {
        this.items = [];
        this.tab = 'all';
        this.keyword = '';
    }

    initialize() {
        this.$list   = $('#b-my');
        this.$status = $('#b-my-status');

        this.bindSearch();
        this.bindTabs();

        // 카드 클릭 → 내제보 상세 BS (상태별 렌더). 변경 시 목록 갱신.
        this.$list.on('click', '.b-myc', (e) => {
            const rno = $(e.currentTarget).data('report');
            if (rno) $j.F.Devil.MyReport.open(rno, () => this.load());
        });

        this.load();
    }

    // 2026-09-14 기획 — 체불 리스트(List.js bindSearch)와 같게: 타이핑 즉시 필터 대신 검색 버튼·Enter 로만 적용.
    // input 은 × 노출 토글에만 쓴다. 목록은 load() 로 한 번 받아 둔 것이라 검색은 클라에서 render() 만 한다.
    bindSearch() {
        const $q = $('#b-my-q');
        const $reset = $('#b-my-reset');
        const $go = $('#b-my-go');

        const syncReset = () => $reset.prop('hidden', !$q.val().length);
        const search = () => { this.keyword = $q.val().trim().toLowerCase(); this.render(); };

        $q.on('input', syncReset);
        $q.on('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); search(); } });
        $go.on('click', search);

        // 리셋: 검색어 비우고 전체 목록으로.
        $reset.on('click', () => {
            $q.val('').focus();
            syncReset();
            if (this.keyword !== '') { this.keyword = ''; this.render(); }
        });
    }

    bindTabs() {
        $('.b-my__tabs .b-pill').on('click', (e) => {
            const $btn = $(e.currentTarget);
            this.tab = $btn.data('tab');
            $('.b-my__tabs .b-pill').removeClass('is-on');
            $btn.addClass('is-on');
            this.render();
        });
    }

    load() {
        this.$status.text('불러오는 중…');
        $.getJSON('/b/ajax/report')
            .done((res) => {
                if (!res || !res.result) { this.$status.text('불러오기 실패'); return; }
                this.items = res.data || [];
                this.updateCounts();
                this.render();
            })
            .fail(() => this.$status.text('불러오기 실패'));
    }

    updateCounts() {
        const cnt = { all: this.items.length, report: 0, draft: 0, reject: 0, collect: 0 };
        this.items.forEach((it) => { const k = TYPE_TAB[it.type]; if (cnt[k] !== undefined) cnt[k]++; });
        Object.keys(cnt).forEach((k) => $(`[data-cnt="${k}"]`).text(cnt[k]));
    }

    render() {
        const filtered = this.items.filter((it) => {
            if (this.tab !== 'all' && TYPE_TAB[it.type] !== this.tab) return false;
            if (this.keyword) {
                const hay = ((it.co_name || '') + (it.phone || '')).toLowerCase();
                if (!hay.includes(this.keyword)) return false;
            }
            return true;
        });

        if (!filtered.length) {
            this.$list.empty();
            this.$status.text(this.keyword ? '검색 결과가 없습니다.' : '해당 제보건이 없습니다.');
            return;
        }
        this.$status.text('');
        this.$list.html(filtered.map((it) => this.cardHtml(it)).join(''));
    }

    cardHtml(it) {
        const R = $j.F.Devil.Render;
        const accent = R.typeAccent(it.type);
        const badge = R.typeBadge(it.type);
        const amtColor = AMT_COLOR[it.type] || '';
        const amt = R.won(it.amount);
        const sub = [it.biz_no].filter(Boolean).join(' ');
        // 반려/해제 사유 표시 — 해제는 사유가 있을 때만
        let reasonHtml = '';
        if (it.type === '반려') {
            reasonHtml = `<p class="b-myc__reject"><b>반려</b> ${R.esc(it.reject_reason || '서류 미비')}</p>`;
        } else if (it.type === '해제' && it.release_reason) {
            reasonHtml = `<p class="b-myc__reject"><b>해제</b> ${R.esc(it.release_reason)}</p>`;
        }

        return `
        <div class="b-card is-press ${accent} b-myc" data-report="${it.num}">
            <div class="b-myc__top">
                <div class="b-myc__badges"><span class="b-badge ${badge}">${R.esc(it.type)}</span></div>
                <span class="b-myc__amt ${amtColor}">${amt}</span>
            </div>
            <p class="b-myc__co">${R.esc(it.co_name)}</p>
            <p class="b-myc__phone">${R.esc(it.phone)}</p>
            <div class="b-myc__foot">
                <span class="b-myc__sub">${R.esc(sub)}</span>
                <span class="b-myc__date">${R.esc(it.date)}</span>
            </div>
            ${reasonHtml}
        </div>`;
    }
}
